/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function GradientRadialFarthestCorner(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'GradientRadialFarthestCorner',
      'aria-hidden': true,
      focusable: false,
      width:  17 * scale,
      height: 14 * scale,
      viewBox: '0 0 17 14',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"opacity":".5","fill":"#41A2F2","d":"M2 2h13v10H2z"}),createElement('path', {"fill":"#7AB8FF","d":"m6.7 7.4 8 5 .6-.8-8-5"}),createElement('path', {"opacity":".4","fill":"currentColor","d":"M2 12V2h13v10zM16 1H1v12h15z"}),createElement('path', {"fill":"currentColor","d":"M6.5 5C5.7 5 5 5.7 5 6.5S5.7 8 6.5 8 8 7.3 8 6.5 7.3 5 6.5 5m7.5 6v2h2v-2z"}))
}
